import { render } from "./Slider.vue?vue&type=template&id=c12e347c&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=c12e347c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c12e347c"

export default script